import { Table } from 'antd';
import { BatchTableColumns } from './BatchTableColumns';
import {
	Pagination,
	PagingConfig,
} from '../../../shared/VolunteerApplicationServiceTypes';
import { Batch } from '../../../shared/PreWorkServiceTypes';
import { tablePaginationConfiguration } from '../../../shared/Utils';

interface BatchTableProps {
	batches: Batch[];
	pagination: Pagination;
	paging: PagingConfig;
	onPageChange: (page: number, pageSize: number) => void;
	handleEditBatch: (batchId: number) => void;
	handleViewBatch: (batchId: number) => void;
	handleViewRegisteredCandidate: (batch: Batch) => void;
	handleEligibleCandidates: () => void;
}

export const BatchTableList = (props: BatchTableProps) => {
	const {
		batches,
		pagination,
		paging,
		onPageChange,
		handleEditBatch,
		handleViewBatch,
		handleViewRegisteredCandidate,
		handleEligibleCandidates,
	} = props;

	const tablePaginationConfig = tablePaginationConfiguration(
		paging,
		pagination,
		onPageChange
	);

	const columns = BatchTableColumns(
		handleEditBatch,
		handleViewBatch,
		handleViewRegisteredCandidate,
		handleEligibleCandidates
	);

	return (
		<>
			<>
				<Table
					columns={columns}
					dataSource={batches}
					pagination={tablePaginationConfig}
					scroll={{ x: 'max-content' }}
					rowClassName={() => 'border-b border-gray-300 bg-white'}
					className="w-full overflow-x-auto !border-separate !border-spacing-y-0"
				/>
			</>
		</>
	);
};
